const validations = {
  type: 'FILE_UPLOAD',
  valueKey: 'fileValue',
};

function getValue(field) {
  const value = field[validations.valueKey];

  if (Object.keys(value || {}).length === 0) {
    field.value = null;
    field.valueObj = {};
    field[validations.valueKey] = {};

    return field;
  }

  field.value = value;
  field.valueObj = value;
  field[validations.valueKey] = value;

  return value;
}

// eslint-disable-next-line no-unused-vars
function setValue(field) {
  // TODO: implement
}

validations.getValue = getValue;
validations.setValue = setValue;

export default validations;
